import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-react'
import type { UserListItem } from '@/api/users'

interface SuperAdminConfirmDialogProps {
	open: boolean
	onOpenChange: (open: boolean) => void
	user: UserListItem | null
	loading?: boolean
	onConfirm: () => void
}

export function SuperAdminConfirmDialog({ open, onOpenChange, user, loading, onConfirm }: SuperAdminConfirmDialogProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-[400px]">
				<DialogHeader>
					<DialogTitle>取消超管确认</DialogTitle>
					<DialogDescription>
						确定要取消用户「{user?.nickname || user?.username}」的超管身份吗？
						取消后该用户将失去所有超管权限，且无法通过部门权限恢复。
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="gap-2 sm:gap-0">
					<Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>取消</Button>
					<Button type="button" variant="destructive" onClick={onConfirm} disabled={loading}>
						{loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
						确认取消
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
